import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouterState, RoutingService, StateUtils } from '@spartacus/core';
import { TrackingPickup } from '@tracking/const';
import { StateWithTracking, TrackingActions, TrackingPickupSelectors } from '@tracking/data-access';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrackingPickupService {
  constructor(
    private store: Store<StateWithTracking>,
    private routingService: RoutingService,
  ) {}

  load(id: string): void {
    this.store.dispatch(new TrackingActions.TrackingPickupLoad(id));
  }

  loadByQueryParams(): void {
    this.getOrderGuidFromQueryParams()
      .pipe(take(1), filter<string>(Boolean))
      .subscribe((id) => {
        this.load(id);
      });
  }

  getTrackingState(id: string): Observable<StateUtils.LoaderState<TrackingPickup>> {
    return this.store.select(TrackingPickupSelectors.getTrackingPickup(id));
  }

  getOrderGuidFromQueryParams(): Observable<string | undefined> {
    return this.routingService.getRouterState().pipe(
      map((state: RouterState) => state.state.params['orderGuid']),
      distinctUntilChanged(),
    );
  }

  getTrackingStateByQueryParams(): Observable<StateUtils.LoaderState<TrackingPickup>> {
    return this.getOrderGuidFromQueryParams().pipe(
      filter<string>(Boolean),
      switchMap((id) => this.getTrackingState(id)),
    );
  }
}
